export enum CostType {
    Direct = 1,
    Indirect = 2
  }

export enum FundingSourceType {
  OwnFunds = 1,
  OtherPublicAuthorities = 2,
  LocalAndRegionalAuthorities = 3,
  Other = 4
}

export enum ProjectBudgetType {
  InitialCopy = 1,
  Reallocation = 2
}